import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './hero-banner.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var HeroBanner = /** @class */ (function (_super) {
    tslib_1.__extends(HeroBanner, _super);
    function HeroBanner(element) {
        return _super.call(this, element) || this;
    }
    HeroBanner.prototype.init = function () {
        var _this = this;
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            },
            autoplay: {
                delay: 7000
            }
        };
        // Slider.init(this.sliderContainer, this.sliderConfig);
        this.slideMain = new Swiper(this.sliderContainer, this.sliderConfig);
        this.slideMain.on('slideChange', function (event) {
            var videos = Array.from(_this.sliderContainer.querySelectorAll('.video'));
            videos.forEach(function (videoContainer) {
                var videosContent = videoContainer.querySelector('.video__player-content');
                videoContainer.classList.remove('video--playing');
                videosContent.innerHTML = '';
            });
        });
    };
    HeroBanner.prototype.bindEvents = function () { };
    return HeroBanner;
}(Base));
export { HeroBanner };



//////////////////
// WEBPACK FOOTER
// ./components/hero-banner/hero-banner.component.ts
// module id = 350
// module chunks = 0